// extracted by mini-css-extract-plugin
module.exports = {"description":"_1zryJH3BY7lbNJr3THp8_Y","pageHeader":"_1M2VLcI2MJNpzKGXkf4V7n","icon":"_2uMi0MqKladsPhQCjW3W0W","table":"_1HTqb57R45I9I9sqLzO68p"};